// extracted by mini-css-extract-plugin
module.exports = {"InteractiveIcon":"InteractiveIcon_InteractiveIcon__2ck7w"};